import { httpService } from '@/api/v1/http.service'
import useMutationWithErrorsHandling from '@/hooks/useMutationWithErrorsHandling'
import { formatApiDate } from '@/utils/format-date'

import {
  schoolYearFieldErrorsMapper,
  type SchoolYearEditFormPayload
} from '../constants/school-year-payload'

const useEditSchoolYear = ({
  onSuccess,
  onError
}: {
  onSuccess: () => void
  onError: () => void
}) =>
  useMutationWithErrorsHandling({
    mutationFn: (payload: SchoolYearEditFormPayload) =>
      httpService.panel.panelPeriodsYearsUpdate(payload.id, {
        first_semester: {
          start_date: formatApiDate(payload.firstSemester.from),
          end_date: formatApiDate(payload.firstSemester.to)
        },
        second_semester: {
          start_date: formatApiDate(payload.secondSemester.from),
          end_date: formatApiDate(payload.secondSemester.to)
        }
      }),
    onSuccess,
    onError,
    fieldErrorsMapper: schoolYearFieldErrorsMapper
  })

export default useEditSchoolYear
